
export const campaignType = {
    WITHOUT_DISCOUNT: "Sin Descuento",
    PERCENTAGE_DISCOUNT: "Descuento %",
    MONEY_DISCOUNT: "Descuento €",
    FREE_DELIVERY: "Envío Gratis"
};